import classnames from 'classnames';
import ChevronIcon from 'components/icons/ChevronIcon';
import isSameMonth from 'date-fns/isSameMonth';
import React from 'react';
import formatDate from 'utils/formatDate';
import { TODAY } from '~/timeConstants';

import WeekHeader from './WeekHeader';

const CSS = require('./DatePickerHeader.module.scss');

interface DatePickerHeaderProps {
  displayedMonth: Date;
  onPrevious?: () => void;
  onNext?: () => void;
  showTwoMonths?: boolean;
}

function DatePickerHeader({
  displayedMonth,
  onPrevious,
  onNext,
  showTwoMonths,
}: DatePickerHeaderProps) {
  return (
    <header className={CSS.DatePickerHeader}>
      <nav
        className={classnames(CSS.Navigation, {
          [CSS.TwoMonthNavigation]: showTwoMonths,
        })}
      >
        <div className={CSS.DisplayedMonth}>
          {formatDate(displayedMonth, 'MMMM yyyy')}
        </div>
        {onPrevious && (
          <button
            type="button"
            onClick={onPrevious}
            className={classnames(CSS.NavButton, CSS.PreviousButton)}
            disabled={isSameMonth(TODAY, displayedMonth)}
          >
            <ChevronIcon
              direction="left"
              width={8}
              height={14}
              className={CSS.ChevronIcon}
            />
          </button>
        )}
        {onNext && (
          <button
            type="button"
            onClick={onNext}
            className={classnames(CSS.NavButton, CSS.NextButton)}
            data-test-id="datepicker-next"
          >
            <ChevronIcon
              direction="right"
              width={8}
              height={14}
              className={CSS.ChevronIcon}
            />
          </button>
        )}
      </nav>
      <WeekHeader />
    </header>
  );
}

export default DatePickerHeader;
